import { render, staticRenderFns } from "./TgTodyInformation.vue?vue&type=template&id=44850d66&"
import script from "./TgTodyInformation.vue?vue&type=script&lang=js&"
export * from "./TgTodyInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports